import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';

export const updateL1TopicDetails = (selectedTopic, allTopics) => ({
  type: types.UPDATE_L1_TOPIC_DETAILS,
  selectedTopic,
  allTopics,
});

export const updateSelectedSubTopicDetails = (selectedSubTopic) => ({
  type: types.UPDATE_L2_SELECTED_TOPIC,
  selectedSubTopic,
});

export const updateSubTopicDetails = (response) => {
  const topics = _get(response, 'webTopicTree');
  const blacklistedMarketICFFlag = _get(response, 'blacklistedMarketICFFlag' || false);
  return {
    type: types.UPDATE_L2_TOPIC_DETAILS,
    topics,
    blacklistedMarketICFFlag,
  };
};

export const updateSelectedL3SubTopic = (selectedL3SubTopic) => ({
  type: types.UPDATE_L3_SELECTED_TOPIC_DETAILS,
  selectedL3SubTopic,
});

export const updateSelectedL3SubTopicDetails = (selectedL3SubTopic, article, breadCrumbItems) => ({
  type: types.UPDATE_L3_SELECTED_TOPIC,
  selectedL3SubTopic,
  article,
  breadCrumbItems,
});

export const updateSelectedArticle = (article) => ({
  type: types.UPDATE_SELECTED_ARTICLE,
  article,
});

export const isL3TopicClicked = () => ({
  type: types.L3_TOPIC_CLICKED,
});

export const resetTopicDetails = () => ({
  type: types.RESET_TOPIC_DETAILS,
});

export const updateTopicDetails = (response, selectedSubTopic) => {
  const topics = _get(response, 'webTopicTree');
  const blacklistedMarketICFFlag = _get(response, 'blacklistedMarketICFFlag' || false);
  const selectedL3SubTopic = selectedSubTopic.subTopicList;
  return {
    type: types.UPDATE_TOPIC_DETAILS,
    topics,
    blacklistedMarketICFFlag,
    selectedSubTopic,
    selectedL3SubTopic,
  };
};
